var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('mybar'),_c('cookie'),_c('v-content',[_c('router-view')],1),_c('myfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }